import React, {useEffect} from 'react';
import moment from 'moment';
import ReactFlagsSelect from 'react-flags-select'

import MaterialModal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import Dialog from '../../../../components/Dialog';
import DoBPicker from '../../../../components/DoBPicker';

import SpotlioIcon from '../../../../components/Icon';

import { getSystemSettings } from '../../../../utils/SettingsRetriever';
import request from '../../../../utils/request';
import { getCookie } from '../../../../utils/CookiesRetriever';
import SalesIDRetriever from '../../../../utils/SalesIDRetriever';

import 'react-flags-select/scss/react-flags-select.scss';
import './Guests.scss';

export default (props) => {
    const emptyGuestForm = {
        isEdit: false,
        firstName: '',
        middleName: '',
        lastName: '',
        emailAddress: '',
        dateOfBirth: '',
        address: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
        homePhone: '',
        mobilePhone: '',
        workPhone: '',
        fax: '',
        memberNumber: '',
        error: ''
    };

    let dobMode = 'required';
    if(getSystemSettings().b2b.guests && getSystemSettings().b2b.guests.dob) {
        dobMode = getSystemSettings().b2b.guests.dob;
    }

    const [ guestForm, setGuestForm ] = React.useState(emptyGuestForm);
    const [ userCookie ] = React.useState(JSON.parse(getCookie('b2b')));
    const [ isModalOpen, setModalState ] = React.useState(false);
    const [ countries, setCountries ] = React.useState([]);
    const [ regions, setRegions ] = React.useState([]);
    const [ countriesRetrieved, setCountriesRetrieved ] = React.useState(false);
    const [ forceModalSpawn, setForceModalSpawn ] = React.useState(false);
    const [ missingRequiredFieldsDiag, setMissingRequiredFieldsDiag ] = React.useState(false);
    const [ saveGuestButtonState, setSaveGuestButtonState ] = React.useState(true);
    const [ isValidatingAddress, setValidatingAddress ] = React.useState(false);
    const [ addressError, setAddressError ] = React.useState(false);

    const verifyAddress = (callback) => {
        if (!getSystemSettings().payment.addressVerification) callback();
        if (['US', 'CA'].indexOf(guestForm.country) >= 0) {
            setValidatingAddress(true);
            setAddressError(null);
            const address = guestForm.address + ', ' + guestForm.city + ' ' + (['US', 'CA', 'MX', 'AU'].indexOf(guestForm.country) >= 0 ? guestForm.state + ' ' : '') + guestForm.postalCode + ' ' + guestForm.country;
            request({
                url: getSystemSettings().api + '/geocoding/validate?apiKey=' + getSystemSettings().payment.mapquestToken + '&address=' + encodeURI(address),
                method: 'GET'
            }).then(response => {
                setValidatingAddress(false);
                if (response.data.points[0].score < 7) { // this is bad
                    setAddressError("Address is not valid!");
                } else { // this is good
                    callback();
                }
            })
        } else {
            callback();
        }
    }

    const handleSaveCreateGuest = (isActive = false) => {
        let url = getSystemSettings().api + '/inntopia/travel-agent/guest/create';
        let uploadData = guestForm;
        uploadData.token = userCookie.token.token;
        uploadData.salesId = userCookie.channel;

        if(uploadData.isEdit){
            url = getSystemSettings().api + '/inntopia/travel-agent/guest/update';
            uploadData.guestId = uploadData.id;
        }

        if (!uploadData.firstName || !uploadData.lastName || !guestForm.address || !guestForm.city || !guestForm.country || !guestForm.postalCode || !guestForm.homePhone || !guestForm.emailAddress) {
            setMissingRequiredFieldsDiag(true);
            return null;
        }

        if(!guestForm.dateOfBirth && dobMode === 'required') {
            setMissingRequiredFieldsDiag(true);
            return null;
        }

        request({
            url: url,
            method: 'POST',
            data: uploadData
        })
        .then( (data) => {
            props.onEditConfirm(data);
            setForceModalSpawn(false);
            handleCloseModal();
            setRegions([]);
        });
    }

    const getCountries = () => {
        request({
            url: getSystemSettings().api + '/inntopia/getCountries',
            method: 'GET',
        })
        .then((data) => {
            let countries = [];
            let sortedCountries = data.data.sort((a, b) => {
                if (a.value < b.value) {
                    return -1;
                }
                if (a.value > b.value) {
                    return 1;
                }
                return 0;
            });
            sortedCountries.forEach(country => {
                countries.push(country.id)
            })
            setCountries(countries);
        });
    }

    const handleFormChange = (event, name) => {
        setAddressError(null);
        setGuestForm({...guestForm, [name]: event.target.value});
        setSaveGuestButtonState(false);
    }

    const handleChangeDate = (date) => {
        setGuestForm({...guestForm, dateOfBirth: date})
    }

    const setCountry = (code, autoSelectRegion = true) => {
        if (code === guestForm.country) return true;
        // handleFormChange({target: {name: 'country', value: code}}, 'country');
        let aux = guestForm;
        aux.country = code;
        setGuestForm(aux);

        request({
            url: getSystemSettings().api + '/inntopia/getStates?state=' + code,
            method: 'GET',
        })
        .then((data) => {
            let regions = [];
            let selectedRegion = '';
            if(data.data.length){
                data.data.forEach((region) => {
                    regions.push(region)
                })

                if(autoSelectRegion){
                    selectedRegion = regions[0].id;
                }
            }
            setRegions(regions);

            if(autoSelectRegion){
                setRegion(selectedRegion);
            }
        })
    }

    useEffect(() => {
        if(guestForm.country !== ''){
            setCountry(guestForm.country, false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guestForm]);

    const setRegion = (region) => {
        handleFormChange({target: {name: 'state', value: region}}, 'state');
    }

    const handleEditUserModal = (id) => {
        request({
            url: getSystemSettings().api + '/inntopia/travel-agent/guest',
            method: 'POST',
            data: {
                token: userCookie.token.token,
                salesId: SalesIDRetriever(),
                guestId: id
            }
        })
        .then((data) => {
            if (data.status === 200) {
                let guestForm = data.data;
                guestForm.isEdit = true;

                if(guestForm.dateOfBirth) {
                    guestForm.dateOfBirth = moment.utc(guestForm.dateOfBirth).format('YYYY-MM-DD');
                } else {
                    guestForm.dateOfBirth = '';
                }

                setGuestForm(guestForm);

                setModalState(true);
            }
        });
    }

    const handleCloseModal = () => {
        setGuestForm(emptyGuestForm);
        props.onEditConfirm();
        setModalState(false);
        setSaveGuestButtonState(true);
    }

    const handleRenderModalContent = () => {
        return (
            <React.Fragment>
                {
                    props.env === "b2b" && (
                        <Button className="CloseModal" onClick={() => handleCloseModal()}>
                            <SpotlioIcon icon="nav-close" />
                        </Button>
                    )
                }
                <div className="ModalContent">
                    <div className="row">             
                        <span className="Required">First Name</span>                  
                        <TextField value={guestForm.firstName} onChange={(e) => handleFormChange(e, "firstName")} className="CreateGuestInput" fullWidth required margin="normal" />
                    </div>
                        {/* <tr>
                            <td className="Description">Middle Name</td>
                            <td>
                                <TextField value={guestForm.middleName} onChange={(e) => handleFormChange(e, "middleName")} className="CreateGuestInput" fullWidth margin="normal" />
                            </td>
                        </tr> */}            
                    <div className="row">              
                        <span className="Required">Last Name</span>                                                              
                        <TextField value={guestForm.lastName} onChange={(e) => handleFormChange(e, "lastName")} className="CreateGuestInput" fullWidth required margin="normal" />   
                    </div>
                    { dobMode !== 'hide' 
                        ? <div className="row">                                         
                            <span className={`Description${dobMode === 'required' ? ' Required' : ''}`}>Date of Birth</span>                                
                            <DoBPicker
                                AgeCalculationBasisDate={moment.utc().format("YYYY/MM/DD")}
                                date={guestForm.dateOfBirth !== '' ? guestForm.dateOfBirth : undefined}
                                placeHolder={"Date of Birth"}
                                handleChangeDate={handleChangeDate.bind(this)}
                            />                                
                          </div> 
                        : null
                    }
                    <div className={`row ${dobMode === 'hide' ? "extended" : ""}`}>  
                        <span className="Required">Address</span>                            
                        <TextField value={guestForm.address} onChange={(e) => handleFormChange(e, "address")} className="CreateGuestInput" fullWidth required margin="normal" />                        
                    </div>
                    <div className="row">  
                        <span className="Required">City</span>                            
                        <TextField value={guestForm.city} onChange={(e) => handleFormChange(e, "city")} className="CreateGuestInput" fullWidth required margin="normal" />
                    </div>
                    <div className="row">  
                        <span className="Required">Country</span>      
                        <div className="CreateGuestInput FlagWrapper">                      
                            <ReactFlagsSelect
                                searchable={true}
                                defaultCountry={guestForm.country}
                                onSelect={(countryCode) => setCountry(countryCode)}
                                countries={countries}
                                searchPlaceholder="Search for a country"
                            />
                        </div>
                    </div>                                 
                        <div style={guestForm.country !== '' && regions.length > 0 ? { display: 'table-row' } : { display: 'none' }}>
                            <span className="Required">Region / State</span>                            
                                <select value={guestForm.state} onChange={(e) => setRegion(e.target.value)}>
                                    {
                                        regions.map((region, index) => {
                                            return (
                                                <option key={index} value={region.id}>{region.value}</option>
                                            )
                                        })
                                    }
                                </select>                            
                        </div>
                        <div className="row">                      
                            <span className="Required">Postal Code</span>                            
                            <TextField value={guestForm.postalCode} onChange={(e) => handleFormChange(e, "postalCode")} className="CreateGuestInput" fullWidth required margin="normal" />                        
                        </div>
                        <div className="row">  
                            <span className="Required">Email Address</span>                            
                            <TextField value={guestForm.emailAddress} onChange={(e) => handleFormChange(e, "emailAddress")} className="CreateGuestInput" fullWidth required margin="normal" />                        
                        </div>
                        <div className="row">  
                            <span className="Required">Home Phone</span>                            
                            <TextField value={guestForm.homePhone} onChange={(e) => handleFormChange(e, "homePhone")} className="CreateGuestInput" fullWidth required margin="normal" />                                                      
                        </div>
                        <div className="row">  
                            <span className="">Mobile Phone</span>
                            <TextField value={guestForm.mobilePhone} onChange={(e) => handleFormChange(e, "mobilePhone")} className="CreateGuestInput" fullWidth margin="normal" />
                        </div>
                        {/* <tr>
                            <td className="Description">Work Phone</td>
                            <td>
                                <TextField value={guestForm.workPhone} onChange={(e) => handleFormChange(e, "workPhone")} className="CreateGuestInput" fullWidth margin="normal" />
                            </td>
                        </tr> */}
                        {/* <tr>
                            <td className="Description">Fax</td>
                            <td>
                                <TextField value={guestForm.fax} onChange={(e) => handleFormChange(e, "fax")} className="CreateGuestInput" fullWidth margin="normal" />
                            </td>
                        </tr> */}
                        <div className="row" style={{display: 'none'}}>
                            <span className="Description">Member Number</span>                          
                            <TextField value={guestForm.memberNumber} onChange={(e) => handleFormChange(e, "memberNumber")} type="number" className="CreateGuestInput" fullWidth margin="normal" />                            
                        </div>                      
                   
                </div>
            </React.Fragment>
        )
    }

    const handleRenderModalFooter = () => {
        return (
            <div className="ModalFooter">
                { isValidatingAddress && <div className="generalMessage info">Verifying...</div> }
                { addressError && <div className="generalMessage error">{addressError}</div> }
                <Button className={props.env === "b2b" ? "Secondary CTA" : "secondary"} onClick={() => handleCloseModal()}>
                    Cancel
                </Button>
                <Button disabled={saveGuestButtonState} className={props.env === "b2b" ? "Primary CTA" : "secondary"} onClick={() => {
                    if (guestForm.isEdit) {
                        handleSaveCreateGuest()
                    } else {
                        if (getSystemSettings().payment.addressVerification === true) {
                            verifyAddress(() => handleSaveCreateGuest());
                        } else {
                            handleSaveCreateGuest();
                        }
                    }
                }}>
                    {guestForm.isEdit ? "Update Guest" : "Create Guest"}
                </Button>
                {props.env === "b2c" ?
                <Button disabled={saveGuestButtonState} className={props.env === "b2b" ? "Primary CTA" : "secondary"} onClick={() => {
                    if (guestForm.isEdit) {
                        handleSaveCreateGuest(true)
                    } else {
                        verifyAddress(() => handleSaveCreateGuest(true));
                    }
                }}>
                    Create Guest and attach
                </Button> : null}
            </div>
        );
    }

    if (!countriesRetrieved) {
        setCountriesRetrieved(true);
        getCountries();
        if (props.forceModalSpawn === true) {
            setModalState(true);
        }
        if (props.userId) {
            handleEditUserModal(props.userId);
        }
    }

    if (props.forceModalSpawn === true && props.userId && forceModalSpawn === false) {
        setForceModalSpawn(true);
        handleEditUserModal(props.userId);
    }

    if (props.forceModalSpawn === false && forceModalSpawn === true) {
        setModalState(false);
        setForceModalSpawn(false);
    }

    return (
        <React.Fragment>
            <Button className={"AddButton " + props.buttonClass} onClick={() => setModalState(true)}>
                {
                    props.env === "b2b" ? (
                        <SpotlioIcon icon="misc-accordion-plus" />
                    ) : (
                        "Create New Guest"
                    )
                }
            </Button>
            {
                props.env === "b2b" ? (
                    <MaterialModal
                        disablePortal={true}
                        className="Modal"
                        aria-labelledby="Create Guest Modal"
                        aria-describedby="Modal to create new guests"
                        open={isModalOpen}
                        onClose={() => handleCloseModal()}>
                        <div className="InnerModal Guest">
                            <h2>{guestForm.isEdit ? "Edit Guest" : "Create a New Guest"}</h2>
                            { handleRenderModalContent() }
                            { handleRenderModalFooter() }
                        </div>
                    </MaterialModal>
                ) : (
                    <Dialog
                        open={isModalOpen}
                        title="Create a New Guest"
                        className="attachGuest Modal newGuest"
                        closeFn={() => handleCloseModal()}
                        footerContent={handleRenderModalFooter()}>
                        <div className="InnerModal Guest">
                            { handleRenderModalContent() }
                        </div>
                    </Dialog>
                )
            }
            <Dialog closeFn={setMissingRequiredFieldsDiag.bind(this, false)} open={missingRequiredFieldsDiag} title="Could not save guest" footerContent={<Button onClick={() => setMissingRequiredFieldsDiag(false)}>Close</Button>}>
                Some required fields are missing.
            </Dialog>
        </React.Fragment>
    );
}
